import * as z from "zod/v4";

export const setUsingDiscountRules = {
  name: "setUsingDiscountRules" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.null(),
};
